import styled from 'styled-components'
import { Col, Button, Form } from 'react-bootstrap'

export const SaveClearAllFilterGroupAction = styled.div`
  display: flex;
  justify-content: center;
  .btn {
    font-size: 1.6rem;
    font-weight: 400;
    padding-right: 0;
    padding-left: 0;
    color: ${({ theme }) => theme.colors.defaultTextColor};
    &:disabled {
      color: ${({ theme }) => theme.colors.headerFontColor};
    }
    &:active,
    &:hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    }
  }

  .clear-filters-button {
    &:active,
    &:focus {
      font-weight: 400 !important;
    }
  }
`
export const SaveCancelGroupAction = styled(Col)`
  display: flex;
  justify-content: center;

  .btn {
    font-size: 1.4rem;
    position: relative;

    /* Reserve space for bold text to prevent layout shift */
    &:before {
      content: attr(data-text);
      font-weight: 600;
      height: 0;
      visibility: hidden;
      overflow: hidden;
      user-select: none;
      pointer-events: none;
      display: block;
      font-size: 1.4rem;
    }
  }
`

export const SaveLink = styled(Button)`
  color: ${({ theme }) => theme.colors.defaultTextColor};

  &:active,
  &:hover {
    color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    font-weight: 600;
  }

  padding-right: 0.5rem;
  padding-left: 0;
`

export const SaveSearchContainer = styled.div`
  background: #fff;
  padding: 1rem 0;

  .btn-link {
    color: ${({ theme }) => theme.colors.defaultTextColor};

    &:active,
    &:hover {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
    }
  }

  .form-check-input {
    margin-left: -2rem;
  }

  .btn {
    font-weight: 400;
    position: relative;

    /* Reserve space for bold text to prevent layout shift */
    &:before {
      content: attr(data-text);
      font-weight: 600;
      height: 0;
      visibility: hidden;
      overflow: hidden;
      user-select: none;
      pointer-events: none;
      display: block;
    }
  }

  .btn:is(:hover, :focus, :active) {
    box-shadow: none;
    text-decoration: none;
    font-weight: 600;
  }
`
export const NotifyContainer = styled(Col)`
  display: flex;
  gap: 2rem;
`

export const SaveSearchFormBody = styled(Form)<{ show: boolean }>`
  display: ${({ show }) => (show ? 'block' : 'none')};

  .form-control:focus {
    border: 1px solid ${({ theme }) => theme.colors.InfinitiOnlyColor};
  }
`

export const ActionSeparator = styled.span`
  font-weight: 600;
  font-size: 1.6rem;
  padding: 0.375rem 0.75rem;

  &::before {
    content: ' | ';
  }
`
